import { authCodeFilterModel } from "config/filterModels/authCodeFilterModel";
import { multipleTerminalFilterModel } from "config/filterModels/multipleTerminalFilterModel";
import { panFilterModel } from "config/filterModels/panFilterModel";
import { rrnFilterModel } from "config/filterModels/rrnFilterModel";
import { FilterModel } from "model/Filter.model";

export const rewardDetailsFilterConfig: FilterModel[] = [multipleTerminalFilterModel, panFilterModel, authCodeFilterModel, rrnFilterModel];
